import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';

export class Notification {
    static jsonMap = {
        dateNotification: { key: 'dateNotification', converter: new DateConverter() },
        reponseOperateur: 'reponseOperateur',
        dateReponseOperateur: { key: 'dateReponseOperateur', converter: new DateConverter() },
        auteurNotification: 'auteurNotification',
        recours: 'recours',
        commentaireOperateur: 'commentaireOperateur',
        commentaireOrganisme: 'commentaireOrganisme'
    };

    dateNotification: moment.Moment;
    reponseOperateur: Boolean;
    dateReponseOperateur: moment.Moment;
    auteurNotification: String;
    recours: Boolean;
    commentaireOperateur: string;
    commentaireOrganisme: string;
}
